import { render } from "./GivingForm3.vue?vue&type=template&id=91052afe&scoped=true"
import script from "./GivingForm3.vue?vue&type=script&lang=js"
export * from "./GivingForm3.vue?vue&type=script&lang=js"

import "./GivingForm3.vue?vue&type=style&index=0&id=91052afe&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-91052afe"]])

export default __exports__